<template>
  <div class="home">
    <Header />
    <Carousel />
    <BusinessSection />
    <ProductSlider />
    <SubscribeSection />
    <Footer />
    <BackToTop />
  </div>
</template>

<script>
// 导入组件
import Header from '../components/Header.vue'
import Carousel from '../components/Carousel.vue'
import BusinessSection from '../components/BusinessSection.vue'
import ProductSlider from '../components/ProductSlider.vue'
import SubscribeSection from '../components/SubscribeSection.vue'
import Footer from '../components/Footer.vue'
import BackToTop from '../components/BackToTop.vue'

export default {
  name: 'Home',
  components: {
    Header,
    Carousel,
    BusinessSection,
    ProductSlider,
    SubscribeSection,
    Footer,
    BackToTop
  }
}
</script>

<style scoped>
.home {
  /* 添加padding-top以避免内容被固定的Header覆盖 */
  padding-top: 91px;
}
</style>